<template>
  <div class="stepsContainer">
    <el-steps :active="props.active" finish-status="success" align-center>
      <el-tooltip
        v-for="step in 8"
        :key="step"
        placement="top"
        popper-class="stepper-tooltip"
        :hide-after="0"
        style="background: #000 !important"
        :disabled="$device.isMobile"
      >
        <template #content>
          <div style="background: #000 !important">
            {{ $t(`flipCoinTooltip${step - 1}`) }}
          </div>
        </template>
        <el-step :style="{ cursor: active === 4 ? 'default' : 'pointer' }">
          <template #icon>
            <div class="iconWrapper">
              <img
                :src="
                  props.active === step - 1
                    ? `/img/tavern/step${step - 1}.svg`
                    : `/img/tavern/step${step - 1}_inactive.svg`
                "
                :alt="`step ${step - 1}`"
                :class="{ activeIcon: props.active === step - 1 }"
                @click="setActiveCallback(step - 1)"
              />
            </div>
          </template>
        </el-step>
      </el-tooltip>
    </el-steps>
  </div>
</template>

<script lang="ts" setup>
import { FlipCoinTabs } from '~/types/FlipCoin';

const props = defineProps<{
  showLoginRequired: boolean;
  active: number;
  setActiveCallback: (step: FlipCoinTabs) => void;
}>();
</script>

<style lang="scss">
.el-popper.is-dark.stepper-tooltip {
  color: #fff !important;
  background: #000 !important;
  border: 1px solid rgb(93, 47, 2, 0.5) !important;
  border-radius: 12px;
}

.stepsContainer .el-steps {
  width: 859px;
  margin-top: 8px;

  @media screen and (max-width: 479px) {
    width: 100%;
    margin-top: 16px;
    gap: 25px;
  }

  .el-step__head.is-success {
    color: unset;
    border-color: unset;
  }

  .el-step {
    .el-step__line {
      background: #000701;
      border: 1px solid #302a27;
      height: 8px;
    }
    .el-step__line-inner {
      border-width: 0 !important;
    }

    cursor: pointer;

    .iconWrapper {
      display: flex;
      justify-content: center;
      align-items: flex-end;
      padding-top: 8px;
    }

    img {
      width: 48px;
      object-fit: contain;
      transition: transform 0.2s ease;

      &.activeIcon {
        width: 62px;
      }
    }

    &__icon {
      background: transparent !important;
    }
  }
}
</style>

<style lang="scss" scoped>
.stepsContainer {
  position: absolute;
  bottom: 15px;
  left: 50%;
  transform: translateX(-50%);

  @media screen and (max-width: 479px) {
    width: 100%;
    overflow-y: hidden;
    overflow-x: auto;
    scrollbar-width: 0;
    &::-webkit-scrollbar {
      display: none;
    }
  }
}

.iconWrapper img {
  background-color: transparent !important;
  border-radius: 50%;
}
</style>
